<template>
  <div id="app"></div>
</template>

<script>
export default {
  data() {
    // var city_id = 1;
    // var citr = 0;
    // localStorage.setItem('city_id',city_id)
    // localStorage.setItem('citr',citr)
    // localStorage.removeItem('token');
    // this.$router.push({
    //     name:'login'
    // })

    var nan = window.location.href;
    console.log(nan)
    if (nan == "https://qy.sqifu.com/#/") {
      var city_id = 26;
      var citr = 1;
      localStorage.setItem("city_id", city_id);
      localStorage.setItem("citr", citr);
      localStorage.removeItem("token");
      this.$router.push({
        name: "zhengwu"
      });
    } else {
      var city_id = 1;
      var citr = 0;
      localStorage.setItem("city_id", city_id);
      localStorage.setItem("citr", citr);
      localStorage.removeItem("token");
      this.$router.push({
        name: "login"
      });
    }
    return {};
  },
  created() {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/Empty.vue